<template>
  <tr v-if="order.isManualStop" class="delivery-row-component"
    :class="{ 'odd-row': index % 2 === 1, 'hover-row': hoverRow }" @mouseenter="hoverRow = true"
    @mouseleave="hoverRow = false">
    <td :rowspan="twoRows" colspan="4">{{ order.statusTitle }}</td>
    <td :rowspan="twoRows" colspan="3" class="clickable" @click="editStop">{{ order.manualStopDescription }}</td>
    <td :rowspan="twoRows" colspan="3" class="clickable" @click="editStop">
      {{ order.manualStopAddress }}
    </td>
    <td class="is-lockable">Kørsel</td>
    <td class="is-lockable">
      <select v-model="order.delivery_zone_id" @change="deliveryZoneChanged" disabled>
        <option :value="null"></option>
        <option v-for="deliveryZone in delivery_zones" :key="deliveryZone.id" :value="deliveryZone.id">
          {{ deliveryZone.title }}
        </option>
      </select>
    </td>
    <td class="is-lockable">
      <select v-if="order.delivery_zone_id === delivery_zone_id" v-model="order.route_code" @change="routeChanged">
        <option :value="null"></option>
        <option v-for="route in tripNames" :key="route" :value="route">
          {{ route }}
        </option>
      </select>
    </td>
    <template v-if="order.route_code">
      <td class="is-lockable">
        <select v-model="order.tour_code" @change="tourCodeChanged">
          <option v-for="stop in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="stop" :value="stop">
            {{ stop }}
          </option>
        </select>
      </td>
      <td class="is-lockable cell-highlight" :class="{ 'pull-down': order.route_code }">
        <time-picker v-model="order.driveStart" :tabindex="100 * tripIndex + (index + 0.5) * 6 + 1" />
      </td>
      <td class="is-lockable cell-highlight" :class="{ 'pull-down': order.route_code }">
        <duration-picker v-model="order.driveDuration" :tabindex="100 * tripIndex + (index + 0.5) * 6 + 2" />
      </td>
      <td class="is-lockable cell-highlight" :class="{ 'pull-down': order.route_code }">
        <time-picker v-model="order.driveEnd" :tabindex="100 * tripIndex + (index + 0.5) * 6 + 3" />
      </td>
      <td class="is-lockable" colspan="3"></td>
    </template>
    <td class="is-lockable" v-else colspan="7"></td>
  </tr>
  <tr v-else class="delivery-row-component" :class="{ 'odd-row': index % 2 === 1, 'hover-row': hoverRow }"
    @mouseenter="hoverRow = true" @mouseleave="hoverRow = false">
    <td :rowspan="twoRows"><status-label :status="order.statusTitle"></status-label></td>
    <td :rowspan="twoRows" class="icon-cell">
      <a :href="order.url" target="blank"><i class="fas fa-link"></i></a>
      <i v-if="order.lastComment" :title="order.lastComment" class="fas fa-comment"></i>
      <a v-if="order.paymentMissing" :href="order.wc_payment_url" target="blank" class="text-danger"><i
          class="fas fa-dollar-sign"></i></a>
    </td>
    <td :rowspan="twoRows" class="column-delimiter"></td>
    <td :rowspan="twoRows">{{ order.total_quantity }}</td>
    <td :rowspan="twoRows">{{ order.productTitle }}</td>
    <td :rowspan="twoRows">{{ order.box_count }}</td>
    <td :rowspan="twoRows" :class="[order.delivery_type == 'warm' ? 'text-danger' : 'text-primary']">
      {{ order.deliveryTypeTitle }}
      <span v-if="order.route_code" class="interval-indicator" :style="safeTransportTimeLimitIndicatorStyle"></span>
    </td>
    <td :rowspan="twoRows" :data-copy-text="order.fullAddress" :title="order.fullAddress">
      {{ order.area }}
    </td>
    <td :rowspan="twoRows">
      {{ order.deliveryDateTime }}
      <span class="interval-indicator" :style="intervalIndicatorStyle"></span>
    </td>
    <td :rowspan="twoRows" class="column-delimiter"></td>
    <td class="is-lockable">Kørsel</td>
    <td class="is-lockable">
      <select v-model="order.delivery_zone_id" @change="deliveryZoneChanged">
        <option :value="null"></option>
        <option v-for="deliveryZone in delivery_zones" :key="deliveryZone.id" :value="deliveryZone.id">
          {{ deliveryZone.title }}
        </option>
      </select>
    </td>
    <td class="is-lockable">
      <select v-if="order.delivery_zone_id === delivery_zone_id" v-model="order.route_code" @change="routeChanged">
        <option :value="null"></option>
        <option v-for="route in tripNames" :key="route" :value="route">
          {{ route }}
        </option>
      </select>
    </td>
    <template v-if="order.route_code">
      <td class="is-lockable">
        <select v-model="order.tour_code" @change="tourCodeChanged">
          <option v-for="stop in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="stop" :value="stop">
            {{ stop }}
          </option>
        </select>
      </td>
      <td class="is-lockable cell-highlight" :class="{ 'pull-down': order.route_code }">
        <time-picker v-model="order.driveStart" :tabindex="100 * tripIndex + (index + 0.5) * 6 + 1" />
      </td>
      <td class="is-lockable cell-highlight" :class="{ 'pull-down': order.route_code }">
        <duration-picker v-model="order.driveDuration" :tabindex="100 * tripIndex + (index + 0.5) * 6 + 2" />
      </td>
      <td class="is-lockable cell-highlight" :class="{ 'pull-down': order.route_code }">
        <time-picker v-model="order.driveEnd" :tabindex="100 * tripIndex + (index + 0.5) * 6 + 3" />
      </td>
      <td class="is-lockable" colspan="3"></td>
    </template>
    <td class="is-lockable" v-else colspan="7"></td>
  </tr>
  <tr v-if="order.route_code" class="delivery-row-component"
    :class="{ 'odd-row': index % 2 === 1, 'hover-row': hoverRow }" @mouseenter="hoverRow = true"
    @mouseleave="hoverRow = false">
    <td class="is-lockable" colspan="4">Service</td>
    <td class="is-lockable pull-up">
      <time-picker v-model="order.deliveryStart" :tabindex="100 * tripIndex + (index + 0.5) * 6 + 4" />
    </td>
    <td class="is-lockable pull-up">
      <duration-picker v-model="order.deliveryDuration" :tabindex="100 * tripIndex + (index + 0.5) * 6 + 5" />
    </td>
    <td class="is-lockable pull-up">
      <time-picker v-model="order.deliveryEnd" :tabindex="100 * tripIndex + (index + 0.5) * 6 + 6" />
    </td>
    <td class="is-lockable" colspan="3"></td>
  </tr>
</template>

<script>
import { ref, computed } from "vue";
import TimePicker from "./TimePicker.vue";
import DurationPicker from "./DurationPicker.vue";
import emitter from "../mitt";
import StatusLabel from './StatusLabel.vue';

export default {
  components: { DurationPicker, TimePicker, StatusLabel },
  emits: ['editStop'],
  props: {
    trip_name: {
      type: String,
      default: null,
    },
    order: {
      type: Object,
      required: true,
    },
    first_order: {
      type: Object,
      default: null,
    },
    delivery_zones: {
      type: Array,
      required: true,
    },
    delivery_zone_id: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    safeTransportTimeLimits: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    const hoverRow = ref(false);

    const twoRows = computed(() => {
      return props.order.route_code ? 2 : 1;
    });

    const tripNames = ["A", "B", "C", "D", "E", "F", "G"];
    const tripIndex = computed(() => {
      return tripNames.indexOf(props.trip_name);
    });

    const getStatusIndicatorColor = (status) => {
      const colors = {
        "Afvist": "#dc3545",
        "Indsendt": "#ffc107",
        "Godkendt": "#28a745",
      };
      return { backgroundColor: colors[status] || "transparent" };
    };

    const intervalIndicatorStyle = computed(() => {
      const color = {
        red: "#dc3545",
        yellow: "#ffc107",
        green: "#28a745",
      };
      // console.log('intervalIndicatorStyle', props.order.deliveryStart, props.order.intervalIndicatorLevel, color[props.order.intervalIndicatorLevel]);
      return {
        backgroundColor: color[props.order.intervalIndicatorLevel] ?? "transparent",
      };
    });

    const safeTransportTimeLimitIndicatorStyle = computed(() => {
      const color = {
        red: "#dc3545",
        yellow: "#ffc107",
        green: "#28a745",
      };

      const deliveryType = props.order.delivery_type; // warm / cold

      const driveStartTime = props.first_order.driveStart; // e.g. "09:15"
      const driveCurrentStopTime = props.order.driveEnd; // e.g. "10:00"

      if (driveStartTime == null || driveCurrentStopTime == null) {
        return;
      }

      // Time limits for transport durations
      const deliveryTimeLimits = {
        warm: {
          low: props.safeTransportTimeLimits.tidPaaBilGulAdvarselVarm,
          high: props.safeTransportTimeLimits.tidPaaBilRodAdvarselVarm,
        },
        cold: {
          low: props.safeTransportTimeLimits.tidPaaBilGulAdvarselKold,
          high: props.safeTransportTimeLimits.tidPaaBilRodAdvarselKold,
        }
      };

      // Function to convert "HH:MM" to total minutes since midnight
      const parseTimeToMinutes = (timeStr) => {
        const [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
      };

      // Calculate time on the road
      const startMinutes = parseTimeToMinutes(driveStartTime);
      let endMinutes = parseTimeToMinutes(driveCurrentStopTime);

      // Handle cases where the delivery crosses midnight
      if (endMinutes < startMinutes) {
        endMinutes += 1440; // Add 24 hours (1440 minutes)
      }

      const minutesEnRoute = endMinutes - startMinutes;

      // Determine color based on time limits
      let colorName = null;

      if (minutesEnRoute >= deliveryTimeLimits[deliveryType]?.high) {
        colorName = "red";
        props.order.setSafeTransportTimeLimitErrors('red', 1)
      } else if (minutesEnRoute >= deliveryTimeLimits[deliveryType]?.low) {
        colorName = "yellow";
        props.order.setSafeTransportTimeLimitErrors('yellow', 1)
      } else if (minutesEnRoute < deliveryTimeLimits[deliveryType]?.low) {
        colorName = "green";
        props.order.setSafeTransportTimeLimitErrors('green', 1)
      }

      return {
        backgroundColor: color[colorName] ?? "transparent",
      };
    });

    let prevDeliveryZoneId = props.order.delivery_zone_id;
    const deliveryZoneChanged = () => {
      emitter.emit("order-delivery-zone-changed", {
        id: props.order.id,
        delivery_zone_id: props.order.delivery_zone_id,
        prev_delivery_zone_id: prevDeliveryZoneId,
      });
      prevDeliveryZoneId = props.order.delivery_zone_id;
    };

    const routeChanged = () => {
      emitter.emit("order-route-changed", {
        id: props.order.id,
        route_code: props.order.route_code,
        prev_route_code: props.order.prevRouteCode,
      });
    };
    const tourCodeChanged = () => {
      emitter.emit("order-tour-code-changed", {
        id: props.order.id,
        tour_code: props.order.tour_code,
        prev_tour_code: props.order.prevTourCode,
      });
    };

    const editStop = () => {
      emit('editStop', props.order.id);
    };

    return {
      hoverRow,
      twoRows,
      tripNames,
      tripIndex,
      intervalIndicatorStyle,
      safeTransportTimeLimitIndicatorStyle,
      deliveryZoneChanged,
      routeChanged,
      tourCodeChanged,
      editStop,
      getStatusIndicatorColor
    };
  },
};
</script>

<style lang="scss" scoped>
.delivery-row-component {
  transition: background-color 0.25s ease, border-color 0.25s ease;

  .icon-cell {
    &>* {
      display: inline-block;
      padding: 4px;
      color: #212529;
      transition: color 0.25s ease;

      &:hover {
        color: #007bff;
      }
    }
  }

  &.odd-row {
    background-color: #f0f0f0;
  }

  &.hover-row {
    background-color: #b8daff;
    border-color: #7abaff;
  }

  .interval-indicator {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-left: 5px;
  }

  .clickable {
    cursor: pointer;
  }
}
</style>
